/** @format */

export const dummyWidget = [
  {
    i: '1',
    isNew: 0,
    w: 3,
    minW: 3,
    maxW: 9,
    h: 7,
    minH: 4,
    maxH: 7,
    type: 'mobility',
    size: 'normal',
    title: 'Smart Mobility Center',
    state: '',
    money: {
      reach: 120000,
      target: 150000
    }
  }, // Smart mobility center,
  {
    i: '19',
    isNew: 0,
    w: 3,
    minW: 3,
    maxW: 9,
    h: 7,
    minH: 7,
    maxH: 7,
    type: 'knowledge_base',
    title: 'Knowledge Base',
    size: 'normal',
    kb_articles: [
      {
        title: 'Test KB Article 3',
        content:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat',
        nid: 147,
        date: 1748515333,
        rating: 3
      },
      {
        title: 'Test KB Article 4',
        content: 'Lorem ipsum dolor sit amet.',
        nid: 148,
        date: 1748515361,
        rating: 5
      },
      {
        title: 'Test KB Article 2',
        content: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.',
        nid: 146,
        date: 1748515304
      }
    ],
    kb: 51
  }, // Knowledge Base
  {
    i: '2',
    isNew: 0,
    w: 6,
    minW: 3,
    maxW: 9,
    h: 7,
    minH: 4,
    maxH: 7,
    type: 'extranet',
    size: 'normal',
    title: 'Aftermarket Extranet',
    data: [
      {
        id: 1,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        category: 'Sales Information'
      },
      {
        id: 2,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        category: 'Sales Information'
      },
      {
        id: 3,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        category: 'Sales Information'
      },
      {
        id: 4,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        category: 'Sales Information'
      },
      {
        id: 5,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        category: 'Sales Information'
      },
      {
        id: 6,
        title: 'SI 116441 – DTCO 4.0 – Remote download SI 116441 – DTCO 4.0 – Remote download',
        date: '02.04.24',
        category: 'Sales Information'
      }
    ]
  }, // Aftermarket Extranet
  {
    i: '7',
    title: 'News & Presse',
    size: 'normal',
    type: 'news',
    isNew: 0,
    w: 9,
    minW: null,
    maxW: null,
    h: 6,
    minH: null,
    maxH: null,
    newsType: 3,
    news: [
      {
        nid: 1,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        content:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: 1748515333,
        category: 'Event Location',
        rating: 4
      },
      {
        nid: 2,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        content:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: 1748515333,
        category: 'Event Location'
      },
      {
        nid: 3,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        content:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: 1748515333,
        category: 'Event Location'
      },
      {
        nid: 4,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        content:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: 1748515333,
        category: 'Event Location'
      },
      {
        nid: 5,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        content:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: 1748515333,
        category: 'Event Location'
      },
      {
        nid: 6,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        content:
          'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: 1748515333,
        category: 'Event Location'
      }
    ]
  }, // News
  {
    i: '3',
    isNew: 0,
    w: 3,
    minW: 3,
    maxW: 9,
    h: 6,
    minH: 4,
    maxH: 7,
    size: 'normal',
    type: 'partnerFinder',
    title: 'VDO Partner',
    terms: ['Brake Center', 'Dealer', 'TPMS Distirbutors', 'General Agent']
  }, // VDO Partner
  {
    i: '4',
    isNew: 0,
    w: 6,
    minW: 3,
    maxW: 9,
    h: 6,
    minH: 6,
    maxH: 9,
    type: 'shop',
    size: 'normal',
    title: 'After Market Webshop -  Bestellungen',
    orders: [
      {
        id: 1,
        number: '468910',
        date: '00.00.0000',
        price: 149.9,
        status: 'in progress'
      },
      {
        id: 3,
        number: '468910',
        date: '00.00.0000',
        price: 149.9,
        status: 'submitted'
      },
      {
        id: 4,
        number: '468910',
        date: '00.00.0000',
        price: 149.9,
        status: 'on hold'
      }
    ]
  }, // Webshop
  {
    i: '5',
    type: 'magazine',
    title: 'Magazin',
    size: 'normal',
    data: [
      {
        id: 1,
        title: 'SINDRI - Vorteile der Fahrzeug-Annahme',
        date: '03.10.24',
        category: 'Event Location',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat',
        thumbnail: '/static/images/dummy_magazin.jpg'
      },
      {
        id: 2,
        title: 'SINDRI - Vorteile der Fahrzeug-Annahme',
        date: '03.10.24',
        category: 'Event Location',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat',
        thumbnail: '/static/images/dummy_magazin.jpg'
      },
      {
        id: 3,
        title: 'SINDRI - Vorteile der Fahrzeug-Annahme',
        date: '03.10.24',
        category: 'Event Location',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat',
        thumbnail: '/static/images/dummy_magazin.jpg'
      },
      {
        id: 4,
        title: 'SINDRI - Vorteile der Fahrzeug-Annahme',
        date: '03.10.24',
        category: 'Event Location',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat',
        thumbnail: '/static/images/dummy_magazin.jpg'
      }
    ],
    isNew: 0,
    w: 6,
    minW: null,
    maxW: null,
    h: 6,
    minH: null,
    maxH: null
  }, // Magazin
  {
    i: '6',
    type: 'support',
    title: 'Support Services 1',
    size: 'normal',
    isNew: 0,
    w: 8,
    minW: 3,
    maxW: 9,
    h: 6,
    minH: 6,
    maxH: 9
  }, // Support
  {
    i: '17',
    type: 'academy',
    title: 'VDOAcademy Trainings',
    size: 'normal',
    trainings: [
      {
        id: 1,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        image: '',
        date: '00.00.0000',
        location: 'Location',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat, Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 2,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        image: '',
        date: '00.00.0000',
        location: 'Location',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat, Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 3,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        image: '',
        date: '00.00.0000',
        location: 'Location',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat, Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      },
      {
        id: 4,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        image: '',
        date: '00.00.0000',
        location: 'Location',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat, Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat'
      }
    ],
    bookings: [],
    isNew: 0,
    w: 4,
    minW: 3,
    maxW: 9,
    h: 6,
    minH: 6,
    maxH: 9
  }, // Academy
  {
    i: '8',
    title: 'KaaS Sandbox',
    content:
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
    category: 'KaaS',
    highlight: true,
    image: '/sites/default/files/2023-11/KaaS%20Website_0.jpg',
    size: 'normal',
    type: 'link',
    linkTarget: '_blank',
    link: 'https://sandbox.eval.itsconnectedcar.com',
    linkTitle: 'Go to Sandbox',
    isNew: 0,
    w: 3,
    minW: 3,
    maxW: 4,
    h: 6,
    minH: 4,
    maxH: 7
  }, // Link
  {
    i: '9',
    title: 'KaaS Production',
    content:
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
    category: 'KaaS',
    highlight: true,
    image: '/sites/default/files/2023-11/KaaS%20Website_0.jpg',
    size: 'normal',
    type: 'link',
    linkTarget: '_blank',
    link: 'https://sandbox.eval.itsconnectedcar.com',
    linkTitle: 'Go to Production',
    isNew: 0,
    w: 3,
    minW: 3,
    maxW: 4,
    h: 6,
    minH: 4,
    maxH: 7
  }, // Link
  {
    i: '10',
    title: 'Download OBD comp list',
    content: 'Download the OBD comp list',
    category: 'KaaS',
    highlight: true,
    image: '/sites/default/files/2023-11/OBD%20Comp%20List.jpg',
    size: 'normal',
    type: 'link',
    linkTarget: '_blank',
    link: 'https://sandbox.eval.itsconnectedcar.com',
    linkTitle: 'Click here',
    isNew: 0,
    w: 3,
    minW: 3,
    maxW: 4,
    h: 6,
    minH: 4,
    maxH: 7
  }, // Link
  {
    i: '11',
    title: 'KaaS Sandbox',
    content:
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
    category: 'KaaS',
    highlight: true,
    image: '/sites/default/files/2023-11/KaaS%20Website_0.jpg',
    size: 'normal',
    type: 'link',
    linkTarget: '_blank',
    link: 'https://sandbox.eval.itsconnectedcar.com',
    linkTitle: 'Go to Sandbox',
    isNew: 0,
    w: 3,
    minW: 3,
    maxW: 4,
    h: 6,
    minH: 4,
    maxH: 7
  }, // Link
  {
    i: '12',
    title: 'Nächste Events & Messen 1',
    size: 'normal',
    type: 'events',
    isNew: 0,
    w: 4,
    minW: 3,
    maxW: 9,
    h: 9,
    minH: 4,
    maxH: 9,
    data: [
      {
        id: 1,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: '03.10.24',
        category: 'Event Location'
      },
      {
        id: 2,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: '03.10.24',
        category: 'Event Location'
      },
      {
        id: 3,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: '03.10.24',
        category: 'Event Location'
      },
      {
        id: 4,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: '03.10.24',
        category: 'Event Location'
      },
      {
        id: 5,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: '03.10.24',
        category: 'Event Location'
      },
      {
        id: 6,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: '03.10.24',
        category: 'Event Location'
      },
      {
        id: 7,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: '03.10.24',
        category: 'Event Location'
      },
      {
        id: 8,
        title: 'WorkshopTab Konfigurator-Tool: Online-Kur',
        text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis nat.',
        date: '03.10.24',
        category: 'Event Location'
      }
    ]
  }, // Events
  {
    i: '13',
    title: 'Multi-videos test',
    size: 'normal',
    type: 'video',
    isNew: 0,
    w: 8,
    minW: 3,
    maxW: 9,
    h: 9,
    minH: 7,
    maxH: 12,
    videos: [
      {
        id: 1,
        content: 'SINDRI - Vorteile der Fahrzeug-Annahme',
        link: 'https://www.youtube.com/watch?v=LlGOsoHAksQ',
        time: '10:11',
        date: '03.10.24',
        category: 'Event Location'
      },
      {
        id: 2,
        content: 'SINDRI - Vorteile der Fahrzeug-Annahme',
        link: 'https://www.youtube.com/watch?v=TkSbUe-icu0',
        time: '10:11',
        date: '03.10.24',
        category: 'Event Location'
      },
      {
        id: 3,
        content: 'SINDRI - Vorteile der Fahrzeug-Annahme',
        link: 'https://www.youtube.com/watch?v=b_qFnL-f-v8',
        time: '10:11',
        date: '03.10.24',
        category: 'Event Location'
      }
    ]
  }, // Videos
  {
    i: '14',
    isNew: 0,
    w: 4,
    minW: 3,
    maxW: 4,
    h: 6,
    minH: 3,
    maxH: 6,
    type: 'info',
    size: 'normal',
    image: '/sites/default/files/2021-09/card.svg',
    title: 'DLK Pro 3.1 Update',
    link: 'https://staging.my.vdo.com/page/53',
    linkTitle: 'Hier gehts zum Update',
    linkTarget: '_blank'
  }, // info
  {
    i: '15',
    isNew: 0,
    w: 4,
    minW: 3,
    maxW: 4,
    h: 6,
    minH: 3,
    maxH: 6,
    type: 'info',
    size: 'normal',
    image: '/sites/default/files/2021-09/cart.svg',
    title: 'VDO Produkte und Umrüstungstermine',
    link: 'https://staging.my.vdo.com/page/117',
    linkTitle: 'Zur Händler Übersicht',
    linkTarget: '_blank'
  }, // info
  {
    i: '16',
    isNew: 0,
    w: 4,
    minW: 3,
    maxW: 4,
    h: 3,
    minH: 3,
    maxH: 6,
    type: 'contact',
    size: 'normal',
    image: '/sites/default/files/2023-11/Write%20pictogram.png',
    title: 'KaaS Contact',
    nid: 27,
    link: 'ContactForm',
    links: null,
    linkTitle: 'Contact Form',
    linkTarget: null,
    tag: null,
    jsSource: null,
    cssSource: null
  }, // contact
  {
    i: '18',
    isNew: 0,
    w: 4,
    minW: 3,
    maxW: 4,
    h: 3,
    minH: 3,
    maxH: 6,
    type: 'contact',
    size: 'normal',
    image: '/sites/default/files/2024-07/multilink.svg',
    title: 'KaaS Contact',
    nid: 27,
    link: 'ContactForm',
    links: null,
    linkTitle: 'Contact Form',
    linkTarget: null,
    tag: null,
    jsSource: null,
    cssSource: null
  } // contact
];
